import { render, staticRenderFns } from "./HealthAuthorizationNotice.vue?vue&type=template&id=3eafe521&"
import script from "./HealthAuthorizationNotice.vue?vue&type=script&lang=ts&"
export * from "./HealthAuthorizationNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports